<template>
  <div v-loading="loading" class="applyForm" style="min-height: 250px">
    <el-form ref="applyForm" :model="applyForm" :rules="rules" label-width="110px">
      <!-- <div class="rj-page-card__title">申请退款</div> -->
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <el-form-item label="电汇编号：">
              {{ id }}
            </el-form-item>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <el-form-item label="可用余额：">
              {{ baseData.unusedAmount }} {{ currencyLabel }}
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item
              label="退款金额："
              prop="returnAmount"
            >
              <el-input-number
                v-model.number="applyForm.returnAmount"
                :precision="2"
                :step="1"
                :min="0"
                placeholder="请输入退款金额"
                style="width: 200px"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="收款单位：" prop="payee">
              <el-input
                v-model="applyForm.payee"
                placeholder="请输入退款理由"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="银行账号：" prop="bankAccount">
              <el-input
                v-model="applyForm.bankAccount"
                placeholder="请输入银行账号"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="开户行：" prop="openBank">
              <el-select
                v-if="isCny"
                v-model="applyForm.openBank"
                style="width: 100%;"
                filterable
                remote
                clearable
                :remote-method="searchCustomerBankBranches"
                :loading="bankBranchLoading"
                placeholder="请输入开户行"
                @change="handleBankBranchChange"
              >
                <el-option
                  v-for="branch in customerBankBranches"
                  :key="branch.branchNo"
                  :label="branch.branchName"
                  :value="branch.branchName"
                />
              </el-select>
              <el-input
                v-else
                v-model="applyForm.openBank"
                placeholder="请输入开户行"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="客户联行号：" prop="customerBankNo">
              <el-input
                v-model="applyForm.customerBankNo"
                placeholder="请输入客户联行号"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="SWIFT CODE：" prop="swiftCode">
              <el-input
                v-model="applyForm.swiftCode"
                placeholder="请输入SWIFT CODE"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="退款理由：" prop="reason">
              <el-input
                v-model="applyForm.reason"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 8 }"
                placeholder="请输入退款理由"
                maxlength="3000"
                show-word-limit
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getRefundApplyInfoByTTNum, searchCustomerBankBranches as searchCustomerBankBranchesApi, telApplyRefundapplyRefund } from '@/API/index';
import eventBus from '@/libs/eventBus';
import { checkExportCompliance } from '@/libs/exportCompliance';
export default {
  name: 'RemittanceApplyBox',

  props: {
    id: {
      type: String,
      required: true
    },
    // 列表行币种（如 USD）；未传时兜底「元」
    currency: {
      type: String,
      default: ''
    }
  },

  data () {
    var checkRefundAmont = (rule, value, callback) => {
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error('退款金额不能小于等于0'));
        } else {
          if (value > this.baseData.unusedAmount) {
            callback(new Error('不能大于可用金额'));
          } else {
            callback();
          }
        }
      }, 100);
    };
    var checkBankInfo = (rule, value, callback) => {
      if (this.isCny && !this.applyForm.customerBankNo) {
        callback(new Error('客户联行号不能为空'));
      } else if (!this.applyForm.customerBankNo && !this.applyForm.swiftCode) {
        callback(new Error('客户联行号和SWIFT CODE不能同时为空'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      applyForm: { payee: '', bankAccount: '', openBank: '', customerBankNo: '', swiftCode: '' },
      baseData: [],
      customerBankBranches: [],
      bankBranchLoading: false,
      bankBranchRequestId: 0,
      rules: {
        returnAmount: [
          { required: true, message: '退款金额不能为空' },
          { validator: checkRefundAmont, trigger: 'blur' }
        ],
        payee: [{ required: true, message: '收款单位不能为空' }],
        bankAccount: [{ required: true, message: '银行账号不能为空' }],
        openBank: [{ required: true, message: '开户行不能为空' }],
        customerBankNo: [{ validator: checkBankInfo, trigger: 'blur' }],
        swiftCode: [{ validator: checkBankInfo, trigger: 'blur' }],
        reason: [{ required: true, message: '退款理由不能为空' }]
      }
    };
  },

  computed: {
    isCny () {
      return String(this.currency).toUpperCase() === 'CNY';
    },
    currencyLabel () {
      return this.currency || '元';
    }
  },

  created () {
    this.getSelectBaseMode();
    eventBus.$on('submitApplyInfo', () => {
      this.submitApply();
    });
  },

  destroyed () {
    eventBus.$off('submitApplyInfo');
  },

  methods: {
    async searchCustomerBankBranches (query) {
      const branchName = (query || '').trim();
      const requestId = ++this.bankBranchRequestId;
      if (!branchName) {
        this.customerBankBranches = [];
        this.bankBranchLoading = false;
        return;
      }
      this.bankBranchLoading = true;
      try {
        const res = await searchCustomerBankBranchesApi(branchName);
        if (requestId === this.bankBranchRequestId) {
          const { status, data } = res.data;
          this.customerBankBranches = status === '200' && Array.isArray(data) ? data : [];
        }
      } catch (error) {
        if (requestId === this.bankBranchRequestId) {
          this.customerBankBranches = [];
        }
      } finally {
        if (requestId === this.bankBranchRequestId) {
          this.bankBranchLoading = false;
        }
      }
    },

    handleBankBranchChange (branchName) {
      const branch = this.customerBankBranches.find(item => item.branchName === branchName);
      this.applyForm.customerBankNo = branch ? branch.branchNo : '';
    },

    async initializeCustomerBankNo () {
      const branchName = (this.applyForm.openBank || '').trim();
      if (!this.isCny || !branchName) {
        return;
      }
      const requestId = ++this.bankBranchRequestId;
      this.bankBranchLoading = true;
      try {
        const res = await searchCustomerBankBranchesApi(branchName);
        if (requestId !== this.bankBranchRequestId) {
          return;
        }
        const { status, data } = res.data;
        this.customerBankBranches = status === '200' && Array.isArray(data) ? data : [];
        const branch = this.customerBankBranches.find(item => item.branchName === branchName) ||
          (this.customerBankBranches.length === 1 ? this.customerBankBranches[0] : null);
        if (branch) {
          this.applyForm.customerBankNo = branch.branchNo;
        }
      } catch (error) {
        if (requestId === this.bankBranchRequestId) {
          this.customerBankBranches = [];
        }
      } finally {
        if (requestId === this.bankBranchRequestId) {
          this.bankBranchLoading = false;
        }
      }
    },

    getSelectBaseMode () {
      getRefundApplyInfoByTTNum({ telegraphicTransferNum: this.id }).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.baseData = data;
          this.applyForm.payee = data.payee;
          this.applyForm.bankAccount = data.bankAccount;
          this.applyForm.openBank = data.openBank;
          this.applyForm.customerBankNo = data.customerBankNo;
          this.applyForm.swiftCode = data.swiftCode;
          this.initializeCustomerBankNo();
        }
      });
    },

    submitApply () {
      this.$refs['applyForm'].validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.applyForm,
            unusedAmount: this.baseData.unusedAmount,
            telegraphicTransferNum: this.id
          };
          this.$emit('set-loading', true);
          let decision;
          try {
            decision = await checkExportCompliance(this, {
              businessScene: 'REFUND_APPLY',
              originalBizId: this.id,
              subjectNameList: [params.payee]
            });
          } catch (error) {
            this.$emit('set-loading', false);
            return;
          }
          if (!decision.allowBusiness) {
            this.$emit('set-loading', false);
            return;
          }
          telApplyRefundapplyRefund(params)
            .then((res) => {
              this.$emit('set-loading', false);
              let { status } = res.data;
              if (status === '200') {
                this.$message.success('提交成功');
                this.sendParent();
              }
            }).catch(() => {
              this.$emit('set-loading', false);
            });
        } else {
          return false;
        }
      });
    },

    sendParent () {
      this.$emit('close', false);
    }
  }

};
</script>

<style lang="scss" scoped>
  .rj-baseinfo{
    width: 100%;
    .el-form-item{
      width: 100%;
    }
  }
</style>
